import { createSelector } from '@reduxjs/toolkit'

import { TAppStore } from '~/src/Configurations/AppStore'

// Selectors
export const SLICE_NAME = 'customer'

const select = (state: TAppStore) => state[SLICE_NAME]

const customerProfileSelect = (state: TAppStore) =>
  state[SLICE_NAME].customerProfile


export const getCustomerProfileSelector = createSelector(
  customerProfileSelect,
  customerProfile => customerProfile
)
